import { sortArray } from "../../../utils/SortArray/SortArray"
import {
    GET_INVENTORY_STARTED,
    GET_INVENTORY_SUCCESS,
    GET_INVENTORY_FAILURE,
    CREATE_PRODUCT_CATEGORY_STARTED,
    CREATE_PRODUCT_CATEGORY_SUCCESS,
    CREATE_PRODUCT_CATEGORY_FAILURE,
    UPDATE_PRODUCT_CATEGORY_STARTED,
    UPDATE_PRODUCT_CATEGORY_SUCCESS,
    UPDATE_PRODUCT_CATEGORY_FAILURE,
    DELETE_PRODUCT_CATEGORY_STARTED,
    DELETE_PRODUCT_CATEGORY_SUCCESS,
    DELETE_PRODUCT_CATEGORY_FAILURE,
    UPDATE_PRODUCT_CATEGORY_ORDER_STARTED,
    UPDATE_PRODUCT_CATEGORY_ORDER_SUCCESS,
    UPDATE_PRODUCT_CATEGORY_ORDER_FAILURE,
    UPDATE_PRODUCT_ORDER_STARTED,
    UPDATE_PRODUCT_ORDER_SUCCESS,
    UPDATE_PRODUCT_ORDER_FAILURE,

    CREATE_PRODUCT_STARTED,
    CREATE_PRODUCT_SUCCESS,
    CREATE_PRODUCT_FAILURE,
    GET_PRODUCT_DETAIL_STARTED,
    GET_PRODUCT_DETAIL_SUCCESS,
    GET_PRODUCT_DETAIL_FAILURE,
    UPDATE_PRODUCT_STARTED,
    UPDATE_PRODUCT_SUCCESS,
    UPDATE_PRODUCT_FAILURE,
    DELETE_PRODUCT_STARTED,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAILURE,
    ADJUST_PRODUCT_STOCK_STARTED,
    ADJUST_PRODUCT_STOCK_SUCCESS,
    ADJUST_PRODUCT_STOCK_FAILURE,
    REMOVE_ERROR_MESSAGE
} from "../../constants/product/product"

const getCategoriesFromLocalStorage = () => {
    const localCategoryData = localStorage.getItem("productCategories")
    if (localCategoryData) {
        const categories = JSON.parse(localCategoryData)
        return categories
    }
    return []
}

const getProductsFromLocalStorage = () => {
    const localProductData = localStorage.getItem("products")
    if (localProductData) {
        const products = JSON.parse(localProductData)
        return products
    }
    return []
}

const flatProducts = (categories) => {
    const allProducts = [];
    categories.forEach(category => {
        if (category.products && category.products.length > 0) {
            allProducts.push(...category.products);
        }
    });
    return allProducts;
}

const initialState = {
    productCategories: getCategoriesFromLocalStorage(),
    products: getProductsFromLocalStorage(),
    productDetail: null,
    loadingDetail: false,
    loading: false,
    error: null,
    message: null,

}

export default function product(state = initialState, action) {
    switch (action.type) {
        case GET_INVENTORY_STARTED: {
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            }
        }
        case GET_INVENTORY_SUCCESS: {
            localStorage.setItem("productCategories", JSON.stringify(action.payload.productCategories))
            localStorage.setItem("products", JSON.stringify(flatProducts(action.payload.productCategories)));
            return {
                ...state,
                loading: false,
                productCategories: action.payload.productCategories,
                products: flatProducts(action.payload.productCategories),
                error: null,
                message: null,
            }
        }
        case GET_INVENTORY_FAILURE: {
            localStorage.removeItem("productCategories");
            localStorage.removeItem("products");
            return {
                ...state,
                loading: false,
                productCategories: [],
                products: [],
                error: action.payload.error,
                message: null,
            }
        }
        case CREATE_PRODUCT_CATEGORY_STARTED: {
            return {
                ...state,
                error: null,
                message: null,
            }
        }
        case CREATE_PRODUCT_CATEGORY_SUCCESS: {
            localStorage.setItem("productCategories", JSON.stringify([...state.productCategories, action.payload.data]))
            return {
                ...state,
                productCategories: [...state.productCategories, action.payload.data],
                error: null,
                message: "Create product category successfully",
            }
        }
        case CREATE_PRODUCT_CATEGORY_FAILURE: {
            return {
                ...state,
                error: action.payload.error,
                message: null,
            }
        }
        case UPDATE_PRODUCT_CATEGORY_STARTED: {
            return {
                ...state,
                error: null,
                message: null,
            }
        }
        case UPDATE_PRODUCT_CATEGORY_SUCCESS: {
            const updatedCategories = state.productCategories.map((category) => {
                if (category._id === action.payload.data._id) {
                    return action.payload.data;
                }
                return category;
            });
            localStorage.setItem("productCategories", JSON.stringify(updatedCategories))
            localStorage.setItem("products", JSON.stringify(flatProducts(updatedCategories)));
            return {
                ...state,
                productCategories: updatedCategories,
                products: flatProducts(updatedCategories),
                error: null,
                message: "Update product category successfully",
            }
        }
        case UPDATE_PRODUCT_CATEGORY_FAILURE: {
            return {
                ...state,
                error: action.payload.error,
                message: null,
            }
        }
        case DELETE_PRODUCT_CATEGORY_STARTED: {
            return {
                ...state,
                error: null,
                message: null,
            }
        }
        case DELETE_PRODUCT_CATEGORY_SUCCESS: {
            const filteredCategories = state.productCategories.filter((category) => category._id !== action.payload.categoryId);
            localStorage.setItem("productCategories", JSON.stringify(filteredCategories))
            localStorage.setItem("products", JSON.stringify(flatProducts(filteredCategories)));
            return {
                ...state,
                productCategories: filteredCategories,
                products: flatProducts(filteredCategories),
                error: null,
                message: "Delete product category successfully",
            }
        }
        case DELETE_PRODUCT_CATEGORY_FAILURE: {
            return {
                ...state,
                error: action.payload.error,
                message: null,
            }
        }
        case UPDATE_PRODUCT_CATEGORY_ORDER_STARTED: {
            return {
                ...state,
                error: null,
                message: null,
            }
        }
        case UPDATE_PRODUCT_CATEGORY_ORDER_SUCCESS: {
            let sortedCategories = sortArray(state.productCategories, action.payload.data, '_id');
            localStorage.setItem("productCategories", JSON.stringify(sortedCategories))
            localStorage.setItem("products", JSON.stringify(flatProducts(sortedCategories)));
            return {
                ...state,
                productCategories: sortedCategories,
                products: flatProducts(sortedCategories),
                error: null,
            }
        }
        case UPDATE_PRODUCT_CATEGORY_ORDER_FAILURE: {
            return {
                ...state,
                error: action.payload.error,
                message: null,
            }
        }
        case UPDATE_PRODUCT_ORDER_STARTED: {
            return {
                ...state,
                error: null,
                message: null,
            }
        }
        case UPDATE_PRODUCT_ORDER_SUCCESS: {
            let sortedCategories = state.productCategories.map(category => {
                return category._id === action.payload.data._id
                    ? action.payload.data
                    : category
            })
            localStorage.setItem("productCategories", JSON.stringify(sortedCategories))
            localStorage.setItem("products", JSON.stringify(flatProducts(sortedCategories)));
            return {
                ...state,
                productCategories: sortedCategories,
                products: flatProducts(sortedCategories),
                error: null,
            }
        }
        case UPDATE_PRODUCT_ORDER_FAILURE: {
            return {
                ...state,
                error: action.payload.error,
                message: null,
            }
        }
        case GET_PRODUCT_DETAIL_STARTED: {
            return {
                ...state,
                loadingDetail: true,
                error: null,
                message: null,
                productDetail: null,
            }
        }
        case GET_PRODUCT_DETAIL_SUCCESS: {
            return {
                ...state,
                loadingDetail: false,
                productDetail: action.payload.data,
                error: null,
                message: null,
            }
        }
        case GET_PRODUCT_DETAIL_FAILURE: {
            return {
                ...state,
                loadingDetail: false,
                productDetail: null,
                error: action.payload.error,
                message: null,
            }
        }
        case CREATE_PRODUCT_STARTED: {
            return {
                ...state,
                loadingDetail: true,
                error: null,
                message: null,
            }
        }
        case CREATE_PRODUCT_SUCCESS: {
            return {
                ...state,
                loadingDetail: false,
                error: null,
                message: "Create product successfully",
            }
        }
        case CREATE_PRODUCT_FAILURE: {
            return {
                ...state,
                loadingDetail: false,
                error: action.payload.error,
                message: null,
            }
        }
        case UPDATE_PRODUCT_STARTED: {
            return {
                ...state,
                loadingDetail: true,
                error: null,
                message: null,
            }
        }
        case UPDATE_PRODUCT_SUCCESS: {
            return {
                ...state,
                loadingDetail: false,
                productDetail: action.payload.data,
                error: null,
                message: "Update product successfully",
            }
        }
        case UPDATE_PRODUCT_FAILURE: {
            return {
                ...state,
                loadingDetail: false,
                error: action.payload.error,
                message: null,
            }
        }
        case DELETE_PRODUCT_STARTED: {
            return {
                ...state,
                loadingDetail: true,
                error: null,
                message: null,
            }
        }
        case DELETE_PRODUCT_SUCCESS: {
            return {
                ...state,
                loadingDetail: false,
                error: null,
                message: "Delete product successfully",
            }
        }
        case DELETE_PRODUCT_FAILURE: {
            return {
                ...state,
                loadingDetail: false,
                error: action.payload.error,
                message: null,
            }
        }

        case ADJUST_PRODUCT_STOCK_STARTED: {
            return {
                ...state,
                loadingDetail: true,
                error: null,
                message: null,
            }
        }
        case ADJUST_PRODUCT_STOCK_SUCCESS: {
            let adjustedProduct = action.payload.data;
            let updatedCategories = state.productCategories.map(category => {
                if (category._id === adjustedProduct.productCategory) {
                    let updatedProducts = category.products.map(product => {
                        if (product._id === adjustedProduct._id) {
                            return adjustedProduct;
                        }
                        return product;
                    });
                    return { ...category, products: updatedProducts };
                }
                return category;
            });
            localStorage.setItem("productCategories", JSON.stringify(updatedCategories));
            localStorage.setItem("products", JSON.stringify(flatProducts(updatedCategories)));
            return {
                ...state,
                loadingDetail: false,
                productCategories: updatedCategories,
                productDetail: action.payload.data,
                error: null,
                message: "Adjust product stock successfully",
            }
        }
        case ADJUST_PRODUCT_STOCK_FAILURE: {
            return {
                ...state,
                loadingDetail: false,
                error: action.payload.error,
                message: null,
            }
        }

        case REMOVE_ERROR_MESSAGE:
            return {
                ...state,
                loading: false,
                error: null,
                message: null
            };
        default:
            return {
                ...state,
            };
    }

}
